import { atomWithStorage } from "jotai/utils";

/**
 * 演出を見せ終えたレベル（=確認済みレベル）をユーザー別に保存する。
 * 共有端末での誤判定を防ぐため userId を併せて保持し、userId 一致時のみ比較に使う。
 *
 * getOnInit: true で localStorage を初期レンダー時に同期読みする。
 * これを付けないとリロード時の初回レンダーで初期値(null)になり、
 * レベルアップ判定が「初回扱い」になって演出されないまま消費されてしまう。
 */
export const storedAiLevelAtom = atomWithStorage<{ userId: string; level: number } | null>(
  "refloop:ai-level:v1",
  null,
  undefined,
  { getOnInit: true }
);
